import config from 'config';
import { http_client } from './api';

const getList = async (query) => {
  return http_client.get(config.apiUrl + 'class-schedule', query).then((response) => {
    return response.data;
  });
};

const getArchiveList = async (query) => {
  return http_client.get(config.apiUrl + 'class-schedule/archive', query).then((response) => {
    return response.data;
  });
};

const getDetail = async (id) => {
  return http_client.get(config.apiUrl + 'class-schedule/' + id).then((response) => {
    return response.data;
  });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'class-schedule', data).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'class-schedule/' + id, data).then((response) => {
    return response.data;
  });
};

const duplicateSchedule = async (id, data) => {
  return http_client.post(config.apiUrl + `class-schedule/${id}/duplicate`, data).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.patch(`${config.apiUrl}class-schedule/${id}/status`, data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'class-schedule/' + id).then((response) => {
    return response.data;
  });
};

const classScheduleService = {
  getList,
  getArchiveList,
  getDetail,
  create,
  update,
  duplicateSchedule,
  changeStatus,
  del
};

export default classScheduleService;
